module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0145.jpg?v=91b7be2b";